<template>
  <div class="filters-container" :class="loading ? 'disabled' : ''">
    <div
      class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
    >
      <div class="d-flex flex-wrap align-items-center">
        <b-form-input
          class="auth-input search-input border-color-light-gray"
          v-model="searchPhrase"
          placeholder="Search patient..."
          :readonly="loading"
        />
        <span class="ml-4 mr-3" style="font-size: 14px;">Active filters:</span>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(pS, pSIndex) in status"
          :key="pS.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Subscriber type:
              <span class="color-filter">{{ pS.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('status', pSIndex)"
            ></i>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(pS, pSIndex) in panel"
          :key="pS.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Panel: <span class="color-filter">{{ pS.label }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('panel', pSIndex)"
            ></i>
          </div>
        </div>
        <div
          v-if="collectionDateFrom || collectionDateTo"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Collection date:
              <span class="color-filter">{{
                collectionDateFrom || collectionDateTo
                  ? `(${
                      collectionDateFrom
                        ? "From: " + formatDateOnly(collectionDateFrom)
                        : ""
                    }${collectionDateFrom && collectionDateTo ? " - " : ""}${
                      collectionDateTo
                        ? "To: " + formatDateOnly(collectionDateTo)
                        : ""
                    })`
                  : ""
              }}</span></span
            >
            <i
              class="fa fa-times hover-pointer hover-text-almost-black"
              @click="removeCollectionDateFilter()"
            ></i>
          </div>
        </div>
        <span
          v-if="hasFilters"
          class="clear-all-filters text-danger ml-2"
          style="font-size: 14px;"
          @click="clearAllFilters"
        >
          Clear all filters
        </span>
      </div>
      <div class="d-flex align-self-stretch align-items-center">
        <div class="align-self-stretch" style="padding: 9px 0px;">
          <div class="vertical-separator border-med-light-gray"></div>
        </div>
        <b-dropdown
          text="Add Filter"
          ref="filterDropdown"
          class="container-main bg-light-gray"
          toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
          menu-class="container-filter-main-menu"
          toggle-tag="div"
          boundary="window"
          right
        >
          <template #button-content>
            <div class="d-flex align-items-center mr-2">
              <i
                class="fas fa-filter text-primary mr-2"
                style="font-size: 15px;"
                aria-hidden="true"
              ></i>
              <span style="font-size: 14px;">Filters</span>
            </div>
          </template>
          <b-dropdown-form class="px-2">
            <b-form-group label="Filter by:">
              <b-form-select
                v-model="selectedFilter"
                :options="filterOptions"
              />
            </b-form-group>

            <multiple-select-filter
              v-if="selectedFilter == 'status'"
              label="Subscriber Type"
              :options="statusList"
              v-model="status"
              :width="'250px'"
              :showSearch="false"
              :key="'status'"
            />
            <multiple-select-filter
              v-if="selectedFilter == 'panel'"
              label="Panel"
              :options="panels"
              v-model="panel"
              :width="'250px'"
              :showSearch="false"
              :key="'panel'"
            />
            <date-range-filter
              v-if="selectedFilter == 'collectionDate'"
              v-model="filterCollectionDateRange"
              :filterWidth="'250px'"
              label="Collection Date"
              :key="'collectionDate'"
            />
          </b-dropdown-form>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import labsServer from "../../server/labs";

export default {
  name: "LabsIndexFilters",
  props: ["value", "hasFilters", "loading", "showing"],
  data() {
    return {
      selectedFilter: "status",
      panels: [],
      orderOptions: [
        {
          value: "name",
          text: "Name"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "panel",
          text: "Panel"
        },
        {
          value: "collectionDate",
          text: "Collection date"
        }
      ],
      filterOptions: [
        {
          value: "status",
          text: "Status"
        },
        {
          value: "panel",
          text: "Panel"
        },
        {
          value: "collectionDate",
          text: "Collection date"
        }
      ],
      statusList: [
        {
          value: "Sent",
          label: "Sent"
        },
        {
          value: "ResultsReceived",
          label: "Results Received"
        }
      ],
      searchTimeout: null
    };
  },
  methods: {
    async fetchPanels() {
      const panels = await labsServer.findAllPanels();
      this.panels = panels.map(panel => ({
        value: panel.id,
        label: panel.name
      }));
    },
    removeIndexFromFilter(filterName, index) {
      const filter = [...this.value[filterName]];
      filter.splice(index, 1);
      this.$emit("input", { ...this.value, [filterName]: filter });
    },
    removeCollectionDateFilter() {
      this.$emit("input", {
        ...this.value,
        collectionDateFrom: null,
        collectionDateTo: null
      });
    },
    clearAllFilters() {
      this.$emit("input", {
        ...this.value,
        searchPhrase: null,
        status: [],
        panel: [],
        isProspect: false,
        collectionDateFrom: null,
        collectionDateTo: null
      });
    }
  },
  computed: {
    searchPhrase: {
      get() {
        return this.value.searchPhrase;
      },
      set(newValue) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = null;
        }
        this.searchTimeout = setTimeout(() => {
          this.$emit("input", { ...this.value, searchPhrase: newValue });
        }, 1000);
      }
    },
    status: {
      get() {
        return this.value.status;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, status: newValue });
      }
    },
    panel: {
      get() {
        return this.value.panel;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, panel: newValue });
      }
    },
    collectionDateFrom: {
      get() {
        return this.value.collectionDateFrom;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, collectionDateFrom: newValue });
      }
    },
    collectionDateTo: {
      get() {
        return this.value.collectionDateTo;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, collectionDateTo: newValue });
      }
    },
    filterCollectionDateRange: {
      get() {
        return {
          dateFrom: this.value.collectionDateFrom,
          dateTo: this.value.collectionDateTo
        };
      },
      set(newValue) {
        this.$emit("input", {
          ...this.value,
          collectionDateFrom: newValue.dateFrom,
          collectionDateTo: newValue.dateTo
        });
      }
    },
    orderBy: {
      get() {
        return this.value.orderBy;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, orderBy: newValue });
      }
    },
    orderByText() {
      return this.orderOptions.find(opt => opt.value == this.orderBy).text;
    },
    orderByDescending: {
      get() {
        return this.value.orderByDescending;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, orderByDescending: newValue });
      }
    },
    sortingOrderClass() {
      return this.value.orderByDescending
        ? "fas fa-sort-amount-down"
        : "fas fa-sort-amount-up";
    }
  },
  watch: {
    showing: {
      handler: function(value) {
        if (value) {
          this.fetchPanels();
        }
      }
    },
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.filters-container {
  overflow-x: auto;
}
.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}
.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 320px;
}
.color-filter {
  color: #909db8;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
div.disabled {
  pointer-events: none;
  opacity: 0.5;
  background: #ccc;
}
.sorting-order-btn {
  background-color: white;
  color: #707070;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  padding: 1px 4px;
}

.filters-container >>> .v-select.vs--disabled .vs__dropdown-toggle {
  background-color: #f8f8f8 !important;
}
</style>
